import styled from 'styled-components';
import { MediaQuery, NeutralColors } from 'theme';

interface ContainerProps {
  isFullscreen: boolean;
  isCollapsed: boolean;
}

const getContainerWidth = (props: ContainerProps) => {
  if (props.isFullscreen) return 'calc(100vw - 64px)';
  if (props.isCollapsed) return '400px';
  return '0px';
};

const Container = styled.div<ContainerProps>`
  background-color: ${NeutralColors[0]};
  width: ${(props) => getContainerWidth(props)};

  position: fixed;
  right: 0;
  top: ${(props) => (props.isCollapsed ? '80px' : '64px')};
  bottom: 0px;

  transition: all 0.5s ease-in-out;
  box-shadow: ${(props) =>
    props.isCollapsed ? '0 2px 8px 0 rgba(0, 0, 0, 0.15)' : 'none'};
  z-index: 10;
  overflow: hidden;
  opacity: ${(props) => (props.isFullscreen || props.isCollapsed ? 1 : 0)};
  visibility: ${(props) =>
    props.isFullscreen || props.isCollapsed ? 'visible' : 'hidden'};

  @media (max-width: ${MediaQuery.screenSizes.desktop - 1}px) {
    width: ${(props) =>
      props.isFullscreen || props.isCollapsed ? '100vw' : '0px'};
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
  }
`;

const Body = styled.div`
  display: flex;
  height: 100%;
  opacity: 1;
  transition: opacity 0.3s ease-in-out 0.2s;
`;

const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

const LeftContainer = styled.div`
  width: 310px;
  background-color: ${NeutralColors[10]};

  @media (max-width: ${MediaQuery.screenSizes.desktop - 1}px) {
    display: none;
  }
`;

export { Body, Container, LeftContainer, RightContainer };
